import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PatientDentalTreatmentplan, PatientDentalTreatmentplanData } from '../../../interfaces/masters/patient-dental-treatmentplan';
import { PatientDentalTreatmentplanApi } from '../api/patient-dental-treatmentplan.api';

@Injectable()
export class PatientDentalTreatmentplanService extends PatientDentalTreatmentplanData{

  constructor(private api: PatientDentalTreatmentplanApi) {
    super();    
  }
  list(url: string): Observable<PatientDentalTreatmentplan[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<PatientDentalTreatmentplan>{
      return this.api.getById(url); 
  }

  create(url: string, data:PatientDentalTreatmentplan): Observable<PatientDentalTreatmentplan> {
    return this.api.add(url,data);
  }

  update(url: string, data:PatientDentalTreatmentplan): Observable<PatientDentalTreatmentplan> {
    return this.api.update(url,data);
  }  

  delete(url: string): Observable<boolean> { 
    return this.api.delete(url);
  } 
}
